import { ModelType } from '@/enums/model-type.enum';

export const LTX_23_LORA_MODEL = 'fal-ai/ltx-2.3-quality/text-to-video/lora';

/** Models whose node footer offers "Add another LoRA" — each click adds a `lora_N` + `lora_N_scale` pair. */
export const LORA_INPUT_MODELS: ReadonlySet<string> = new Set<string>([
  ModelType.FalFluxMultiLora.valueOf(),
  ModelType.FalFluxMultiLoraInpaint.valueOf(),
  ModelType.FalFluxKontextLora.valueOf(),
  LTX_23_LORA_MODEL,
]);
